import axios from 'axios';

const API_KEY = process.env.REACT_APP_API_KEY || 'tu-api-key-aqui';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://claudio.trading',
  timeout: 90000,
  headers: {
    'X-API-Key': 'X7k#mP9@qR2nL5vW',
  },
});

export const api = {
    // Agent
    getStatus: () => client.get('/api/agent/status'),
    getAccount: () => client.get('/api/agent/account'),
    getPositions: () => client.get('/api/agent/positions'),
    pauseAgent: () => client.post('/api/agent/pause'),
    resumeAgent: () => client.post('/api/agent/resume'),
	getPrice: (symbol) => client.get(`/api/agent/prices?symbols=${symbol}`),
	getRiskStatus: () => client.get('/api/agent/risk-status'),
	getPricesLive: (symbols) => client.get(`/api/agent/prices/live?symbols=${symbols}`),

    // Strategies
	getStrategies:  () => client.get('/api/v2/strategies'),
	toggleStrategy: (id) => client.post(`/api/v2/strategies/${id}/toggle`),
	updateStrategy: (id, data) => client.put(`/api/v2/strategies/${id}`, data),

    // Decisions
    getDecisions: (params) => client.get('/api/agent/decisions', { params }),

    // Trades
	getTrades:        (params) => client.get('/api/agent/trades', { params }),
	getLivePositions: ()       => client.get('/api/agent/positions/live'),
	closePosition:    (id)     => client.post(`/api/agent/close-position/${id}`),
	
	getGymData: () => client.get('/api/gym/data'),
	getBacktestResults: (params) => client.get('/api/gym/results', { params }),
	runBacktest:        (data)   => client.post('/api/gym/backtest', data),
	getBacktestDetail:  (id)     => client.get(`/api/gym/results/${id}`),
	getBacktestTrades: (id) =>
	  client.get(`/api/gym/results/${id}/trades`).then(r => r.data),

	getBacktestCandles: (id) =>
	  client.get(`/api/gym/candles/${id}`).then(r => r.data),
};

export default client;